const useCompositePreferencesHandle = require('./useCompositePreferencesHandle');
const useFormComponentRegistry = require('./useFormComponentRegistry');
const useFormInputRefs = require('./useFormInputRefs');
const useManagedFormStateWithLocation = require('./useManagedFormStateWithLocation');

const internals = {};

internals.buildFormModel = ({
    defaults,
    fields
}) => ({
    fields,
    defaults
});

internals.buildDefaultRendererProps = ({
    formConfig,
    formState,
    inputRefs,
    preferencesHandle,
    props
}) => ({
    ...props,
    formConfig,
    formMethods: formState.methods,
    inputRefs,
    locationStateActions: formState.locationStateActions,
    preferencesHandle,
    stillExistsRef: formState.stillMountedRef
});

module.exports = function useManagedFormController({
    buildRendererProps,
    formConfig,
    formStateOptions = {},
    props = {}
}) {

    const inputRefs = useFormInputRefs(formConfig);
    const preferencesHandle = useCompositePreferencesHandle();
    const formState = useManagedFormStateWithLocation({
        formConfig,
        props,
        ...formStateOptions
    });
    const formModel = internals.buildFormModel(formState);
    const defaultRendererProps = internals.buildDefaultRendererProps({
        formConfig,
        formState,
        inputRefs,
        preferencesHandle,
        props
    });
    const rendererProps = typeof buildRendererProps === 'function'
        ? buildRendererProps({
            defaultRendererProps,
            formConfig,
            formModel,
            formState,
            inputRefs,
            preferencesHandle,
            props
        })
        : defaultRendererProps;

    useFormComponentRegistry(formConfig);

    return {
        formConfig,
        formModel,
        inputRefs,
        instanceKey: formState.instanceKey,
        methods: formState.methods,
        preferencesHandle,
        rendererProps
    };
};

module.exports.internals = internals;
